import { initOneSignal } from '../../oneSignal'

export default function initializeOneSignal (): void {
  initOneSignal()
}
